import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { ModalType } from '@/components/modals/modal-types'
import { isContentOwner, isContentEditor, isContentAccounting, isOrganizationAdmin, isPublisherEditor, isPublisher } from '@/services/utils'

/**
 * The panel is hidden:
 * - When no user is logged in
 * - For non-content users and non-organization-admin users
 * - On routes with hideProcessingPanel or fullscreen meta flags
 * - When onboarding modal is active
 */
export function useProcessingPanelVisibility() {
  const route = useRoute()
  const store = useStore()

  const shouldShowPanel = computed(() => {
    const userId = store.state.user?.user?.id
    if (!userId || userId <= 0) {
      return false
    }

    const isAuthorizedForVisiblePanel =
      isPublisher() ||
      isPublisherEditor() ||
      isContentOwner() ||
      isContentEditor() ||
      isContentAccounting() ||
      isOrganizationAdmin()

    if (!isAuthorizedForVisiblePanel) {
      return false
    }

    if (route.meta.hideProcessingPanel || route.meta.fullscreen) {
      return false
    }

    const modalType = store.getters['modal/getModalType']()
    if (modalType === ModalType.ONBOARDING) {
      return false
    }

    return true
  })

  return { shouldShowPanel }
}
